export const SUBSCRIPTION_LIMITS = {
  P0: { maxComments: 5, maxPictures: 5, maxEventsPerMonth: 3 },
  P1: { maxComments: 0, maxPictures: 0, maxEventsPerMonth: 0 },
  P2: { maxComments: 500, maxPictures: 500, maxEventsPerMonth: 0 },
  P3: { maxComments: 1000, maxPictures: 1000, maxEventsPerMonth: 3 },
  P4: { maxComments: 5000, maxPictures: 5000, maxEventsPerMonth: 100 },
  P5: { maxComments: 5000, maxPictures: 5000, maxEventsPerMonth: 100 },
};


export const SUBSCRIPTION_ACCESS = {
  text: ['P0', 'P2', 'P3', 'P4', 'P5'],
  fond: [ 'P0', 'P2', 'P3', 'P4', 'P5'],
  font: [ 'P0', 'P2', 'P3', 'P4', 'P5'],
  taille: ['P0', 'P2', 'P3', 'P4', 'P5' ],
  animation: [ 'P0', 'P2', 'P3', 'P4', 'P5' ],
  bgimage: [  ],
  transition: [ 'P0', 'P2', 'P4', 'P5' ],
  qr: [ 'P0', 'P2', 'P3', 'P4', 'P5' ],
  banner: [ 'P4', 'P5' ],
  watermark: ['P2', 'P3', 'P4', 'P5'],
};
